"use client";
import r from"react";import{FGStack as t}from"../FGStack/FGStack.js";var e=function(e){var c=e.children;return r.createElement(t,{gap:8,direction:"column"},c)};export{e as FGMediaObjectBody};
//# sourceMappingURL=FGMediaObject.components.js.map
